import { useNavigate } from 'react-router-dom'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'

import type { SoftwareAssuranceWorkflowController } from '@/hooks/workflow/useSoftwareAssuranceWorkflow'

interface ReviewStepSectionProps {
  workflow: SoftwareAssuranceWorkflowController
}

export function ReviewStepSection({ workflow }: ReviewStepSectionProps) {
  const navigate = useNavigate()

  return (
    <div className="space-y-3">
      <h4 className="text-sm font-semibold">Human-in-the-Loop Review</h4>
      <p className="text-sm text-muted-foreground">
        Vet observations, assign RC/EM values, and promote to findings.
      </p>
      {workflow.observationCounts ? (
        <div className="grid gap-2 rounded-lg border border-border p-3 bg-muted/20">
          <div className="flex items-center justify-between text-sm">
            <span>Total Observations</span>
            <Badge variant="secondary">{workflow.observationCounts.total}</Badge>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs text-muted-foreground">
            <div>Pending: {workflow.observationCounts.by_status.pending}</div>
            <div>Confirmed: {workflow.observationCounts.by_status.confirmed}</div>
            <div>False Positive: {workflow.observationCounts.by_status.false_positive}</div>
            <div>Mitigated: {workflow.observationCounts.by_status.mitigated}</div>
            <div>Deferred: {workflow.observationCounts.by_status.deferred}</div>
          </div>
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">Select a mission to view vetting backlog.</p>
      )}
      <Button variant="outline" onClick={() => navigate('/softwareiq/assurance/vetting')}>
        Open Vetting Queue
      </Button>
    </div>
  )
}
